import {useEffect, useState} from 'react'
import { colors } from '@styles/vars/colors.style'

const useGetColor = (color, bgColor, tColor) => {
    const [bg, setBg] = useState();
    const [text, setText] = useState();
    useEffect(() => {

        if(color === 'Black') {
            setBg(colors.charcoal)
        }else if(color === 'Page Background') {
            setBg(bgColor)
        }else if(color === 'Page Text') {
            setBg(tColor)
        }else {
            setBg(colors.white)
        }

        if(color === 'Black') {
            setText(colors.white)
        }else if(color === 'Page Background') {
            setText(tColor)
        }else if(color === 'Page Text') {
            setText(colors.charcoal)
        }else {
            setText(colors.charcoal)
        }
        
    }, [color, bgColor, tColor]);
    return [bg, text]
}

export default useGetColor